import Vue from 'vue';
import PartFinder from '~/modules/part-finder/components/PartFinder.vue';
import LicensePlateFinder from '~/modules/part-finder/components/LicensePlateFinder.vue';

Vue.component('LicensePlateFinder', LicensePlateFinder);
Vue.component('PartFinder', PartFinder);